/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { tenantsRotateApiKey } from "../../funcs/tenantsRotateApiKey.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRotateRequestBody$inboundSchema,
};

export const tool$tenantsRotateApiKey: ToolDefinition<typeof args> = {
  name: "tenants_rotate-api-key",
  description: `Rotate tenant API key

Rotates a tenant API key while maintaining its configuration`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await tenantsRotateApiKey(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
